<div class="title" mat-dialog-title>
  <mode-dialog-header>
    <div class="flex-center" heading>
      <capra-icon heading class="header-icon" icon="icon-warning"></capra-icon>
      <h1 heading>Unpublish Dataset?</h1>
    </div>
  </mode-dialog-header>
</div>
<section class="body">
  <p class="sub-text">
    This action will permanently break content in the data workspace unless this Dataset is republished with its
    original name.
  </p>
  <p class="bold-text unset-margin">The following will break:</p>
  <ul class="unset-margin">
    <li>the published table imported in the Data workspace</li>
    <li>any dependent Models or Worksheets</li>
    <li>any dependent Liveboards</li>
    <li>any dependent Answers</li>
  </ul>

  <form class="ack-form" [formGroup]="form">
    <span class="checkbox-icon option-field">
      <input
        id="acknowledgment-input"
        name="acknowledgment-input"
        type="checkbox"
        formControlName="acknowledged"
        data-test="acknowledgment-input"
      />
      <label
        for="acknowledgment-input"
        class="ack-label inline-icon icon-editor-checkbox-light-unchecked"
        data-test="acknowledgment-label"
      >
        I understand this will break content in the data workspace
      </label>
    </span>
  </form>
</section>

<div mat-dialog-actions>
  <capra-button
    class="cancel-btn"
    text="Cancel"
    data-test="cancel-unpublish-cta"
    variant="secondary"
    color="neutral"
    (clicked)="close()"
  ></capra-button>
  <capra-button
    text="Unpublish"
    data-test="unpublish-cta"
    color="alert"
    [disabled]="!form.valid"
    (clicked)="unpublishDataset()"
  ></capra-button>
</div>
